export default "__VITE_ASSET__CJvH1spM__"